import { useMemo } from 'react';

import config from 'config';

import { useMembership as reactPackageUseMembership } from '@techstyle/react-accounts';
import { useDomain } from '@techstyle/redux-core';

export function useMembership() {
  const defaultMembershipPrice = config.get('public.globalMembershipPrice');
  const membership = reactPackageUseMembership();
  const { tld } = useDomain();

  const memoizedMembership = useMemo(() => {
    const updatedMembership = { ...membership };

    if (!updatedMembership.price) {
      updatedMembership.price = defaultMembershipPrice[tld];
    }

    return updatedMembership;
  }, [membership, defaultMembershipPrice, tld]);

  return memoizedMembership;
}
